












import { Component, Prop, Vue } from "vue-property-decorator";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";

@Component({
  components: {
    ConfirmDialogComponent
  }
})
export default class ReportSaveDialogComponent extends Vue {
  @Prop({
    default: false
  })
  public display!: boolean;

  @Prop({
    default: "successively"
  })
  public type!: string;

  @Prop({
    default: ""
  })
  public path!: string;

  get title() {
    if (this.type === "successively") {
      return "レポートを作成しました";
    }
    return "定期レポートを作成しました";
  }
  get body() {
    if (this.type === "successively") {
      return "システム上作成及び、メール配信まで数分かかる場合があります";
    }
    return "作成した定期レポートは、定期レポート一覧から編集できます。";
  }
  get query() {
    if (this.type === "successively") {
      return null;
    }
    return { type: "reqular" };
  }
}
